import React, { memo } from 'react'
import { Container } from './FixedLoader.styles'

interface FixedLoaderProps {
	loading: boolean
}

/**
 * Full-screen loading overlay with spinner.
 * Renders nothing when loading is false.
 */
export default memo(function FixedLoader({ loading }: FixedLoaderProps) {
	if (!loading) return null

	return (
		<Container 
			className="shown"
			role="status"
			aria-live="polite"
			aria-label="Loading"
		>
			<div className='lds-roller' aria-hidden="true">
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
			</div>
		</Container>
	)
})
